<template>
	<div class="box dis_flex">
		<div class="left">
			<cl-exercise-detail-left :practice="practiceObj.practice" :action="action" :templateItem="templateItem"></cl-exercise-detail-left>
		</div>
		<div class="right">
			<cl-svg-icon
				v-if="action==='edit'"
				class="right_edit_icon"
				icon-class="edit"
				width="24"
				style="color: #81818A;"
				@click.native="handleEditClick"
			></cl-svg-icon>

			<p class="Major_Color fs16 mb24 SysFontM">{{$t(`schedule.内容`)}}</p>
			<el-input
				v-if="action !== 'view'"
				class="desc"
				v-model="practice.desc"
				type="textarea"
				:rows="4"
				:autosize="{ minRows: 4 }"
				:placeholder="$t('common.请输入')"
			></el-input>
			<pre v-else class="Minor_Color fs14 mb32" style="line-height: 26px;">{{practice.desc}}</pre>
			<h6 v-if="practice.files && practice.files.length">{{ $t('schedule.附件') }}</h6>
			<cl-file-list v-model="practice.files" :disabled="action === 'view'"></cl-file-list>
		</div>
	</div>
</template>

<script>
    import clExerciseDetailLeft from './cl-exercise-detail-left.vue'
    export default {
        name: 'cl-exercise-view',
        components: { clExerciseDetailLeft },
        props: {
			practice: {
				type: Object,
				default: () => ({})
			},
            action: {
                type: String,
                default: 'view',
            },
			templateItem: {
				type: Object,
				default: () => ({})
			}
        },

        data() {
            return {
                practiceObj: {}
            }
        },

        watch: {
            practice: {
                deep: true,
                immediate: true,
                handler(newV){
                    this.practiceObj = this.$utils.deepCopy(newV)
                    if(this.practiceObj.practice) {
                        this.practiceObj.practice.drawingThumbnail = this.practiceObj.practice.drawing_thumbnail || this.practiceObj.practice.drawingThumbnail;
                    }
                }
            }
        },

        computed: {},

        methods: {
			handleEditClick() {
				this.$emit('handle-edit-click')
			}
		},

        created() {},

        mounted() {},

        beforeDestroy() {},
    }
</script>
<style lang="scss" scoped>
    .box {
        margin-top: 16px;
        padding: 32px;
        background: #fff;
        border-radius: 6px;
    }
    .dis_flex {
		position: relative;
        display: flex;
    }
	.left {
		width: 338px;
		height: 447px;
	}
    .right {
		margin-left: 32px;
        flex: 1;
        font-family: 'PingFang SC';
        font-style: normal;
        font-size: 14px;
		.right_edit_icon {
			position: absolute;
			top: 16px;
			right: 16px;
		}
        h6 {
            margin-bottom: 10px;
            font-weight: 500;
            line-height: 20px;
            color: #3a3a3a;
        }
        .desc {
            margin-bottom: 20px;
            font-weight: 400;
            line-height: 26px;
            color: #81818a;
        }
    }
</style>
